import styled from 'styled-components'
import { noTouch } from '@/assets/styles/mixins.css.js'

const Social = styled.a`
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  width: var(--social-width, 40px);
  height: var(--social-height, 40px);
  background-color: var(--social-bg-color, #fff);
  border: 1px solid var(--social-border-color, #fff);
  border-radius: 50%;
  transform-origin: 50% 50%;
  transform: none;
  will-change: transform;
  transition: transform 0.3s ease-in;

  ${noTouch()`
    &:hover {
      transform: scale(1.1);
      transition: transform 0.3s ease-out;
    }
  `}
`

export default Social
